// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect  } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const ApproveWithdrawalModal = ({
    approveWithdrawalModalOpen,
    setApproveWithdrawalModalOpen,
    withdrawalRow,
    fetchWithdrawal
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);
    
    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateWithdrawal = async () => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/Withdrawal',
                {
                    id: withdrawalRow.id,
                    statusID: 2
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功批准提款');
                fetchWithdrawal();
                setApproveWithdrawalModalOpen(false);
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    return (
        <>
            <Modal
                open={approveWithdrawalModalOpen}
                onClose={() => setApproveWithdrawalModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("withdrawal.approveWithdrawal")}
                        </Typography>
                        <Cancel onClick={() => setApproveWithdrawalModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '25px',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            marginTop: '30px'
                        }}
                    >
                        {t("withdrawal.confirmApproveWithdrawal")} ?
                    </Typography>
                    <Box style={{alignItems: 'center', textAlign: 'center'}}>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '30px'
                            }}
                            onClick={submitUpdateWithdrawal}
                            disabled={updateButtonDisabled}
                        >
                            {t("withdrawal.confirm")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: 'grey',
                                marginTop: '30px',
                                marginLeft: '30px'
                            }}
                            onClick={() => setApproveWithdrawalModalOpen(false)}
                            disabled={updateButtonDisabled}
                        >
                            {t("withdrawal.cancel")}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default ApproveWithdrawalModal;